// Signing out: the push row first, while the bearer still works, then the tokens, then the landing page. Also where
// the cabinet goes when a refresh is refused (AuthHeaderHandler signed out the same way).

import { clearSession } from './auth.ts';
import { whenSessionLost } from './cabinet-api.ts';
import { unregister } from './push.ts';

let signingOut: Promise<void> | null = null;

export function logout(): Promise<void> {
    if (!signingOut) {
        signingOut = (async () => {
            await unregister();
            clearSession();
            location.assign('/');
        })().finally(() => {
            signingOut = null;
        });
    }

    return signingOut;
}

whenSessionLost(logout);
